export default "__VITE_ASSET__fee3779f__"